import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import AppView from './components/View';

import i18n from '../../../config/i18n';
import { apiSetup } from '../../../config/api';

import { actionCreators as authActions } from '../../../redux/Auth/actions';

class AppInitializer extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    isLoading: PropTypes.bool.isRequired,
    refresh: PropTypes.func.isRequired,
    setupApi: PropTypes.func.isRequired,
  };

  async componentDidMount() {
    const { refresh, setupApi } = this.props;
    setupApi();
    // We also load the common namespace
    i18n.loadNamespaces('common', () => {
      // We check the old tokens and if they are still valid, let's refresh them.
      refresh();
    });
  }

  render() {
    const { isLoading, children } = this.props;
    return (
      <React.Fragment>
        <AppView isLoading={isLoading}>
          {children}
        </AppView>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    isLoading: !state.application.initialized,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(authActions, dispatch),
    setupApi() {
      apiSetup(dispatch);
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AppInitializer);



// WEBPACK FOOTER //
// ./src/app/components/Initializer/index.js